import type { JSX } from 'react';
import { Message, MessageHeader } from 'ts/components/Message';
import type { QueryParserFailure } from 'typedefs/QueryParserFailure';

/** Props for QueryParserFailureMessage. */
type QueryParserFailureMessageProps = {
	queryParserFailure: QueryParserFailure;
};

/** Shows a query parser failure highlighting the erroneous token is applicable. */
export function QueryParserFailureMessage({ queryParserFailure }: QueryParserFailureMessageProps): JSX.Element {
	const startPosition = queryParserFailure.startPosition;
	const endPosition = queryParserFailure.endPosition;
	let query: JSX.Element | null = null;
	if (startPosition != null && endPosition != null) {
		const queryString = queryParserFailure.query;
		const leftSide = queryString.slice(0, startPosition);
		const unparseableTokens = queryString.slice(startPosition, endPosition);
		const rightSide = queryString.slice(endPosition, queryString.length);
		query = (
			<p>
				{leftSide} <span id="unparseable-tokens">{unparseableTokens}</span> {rightSide}
			</p>
		);
	}
	return (
		<Message error>
			<MessageHeader>Failed to execute query</MessageHeader>
			<p>{queryParserFailure.message}</p>
			{query}
		</Message>
	);
}
